import { getIconByName } from '../../../utils/iconUtils';
import { Check } from 'lucide-react';

/**
 * Les bénéfices, à icônes.
 *
 * L'icône est un NOM lucide-react, pas un fichier : elle ne se traduit pas
 * et ne s'héberge pas. Un nom inconnu se replie sur une coche plutôt que de
 * laisser un trou dans la grille.
 */
const ArgumentsBloc = ({ bloc }) => {
    const args = Array.isArray(bloc?.arguments) ? bloc.arguments : [];
    if (args.length === 0) return null;

    return (
        <section className="mb-10" data-testid="bloc-arguments">
            {bloc.titre && (
                <h2 className="text-xl font-bold text-gray-900 mb-5">{bloc.titre}</h2>
            )}
            <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {args.map((a, i) => {
                    const Icone = getIconByName(a.icone, Check);
                    return (
                        <div key={i} className="flex gap-3">
                            <div className="flex-shrink-0 w-9 h-9 rounded-lg flex items-center justify-center bg-gradient-to-br from-cabaza-purple/10 to-cabaza-pink/10">
                                <Icone className="w-5 h-5 text-cabaza-purple" />
                            </div>
                            <div>
                                {a.titre && (
                                    <h3 className="font-semibold text-gray-900">{a.titre}</h3>
                                )}
                                {a.texte && (
                                    <p className="text-sm text-gray-600 mt-0.5">{a.texte}</p>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

export default ArgumentsBloc;
